module.exports = __webpack_public_path__ + "static/media/www.kaivohuone.fi.8f6d2da2.jpg";